import { ERasterAnalysis } from '../types/layers';

const { EVI, GNDVI, SAVI, NDVI } = ERasterAnalysis;

export const leftpanel = {
  minBufferDistance: 1,
  maxBufferDistanceMeters: 5000,
  maxBufferDistanceFeet: 16500,
  vegetationIndexes: [NDVI, GNDVI, SAVI, EVI],
  hansenEndYear: 2020,
};
